import React, { useCallback, useEffect, useState, useRef } from "react";
import { Table, TableBody, TableCell, TableRow, Button } from "@material-ui/core";
import { ViewHubParaContainer, ViewTableContainer, BackButtonContainer, ErrorSectionDiv, SubHeaderSection, SpinnerContainer, HubParamModal, FileUploadSpinner,
    EditTableContainer, GenCSRButton, AutoGenDiv, FooterSection, EditActions, FormErrorContainer, ErrorSection, HyperLinkDiv, CertDetailsTable,
    ErrorIconContainer, StatusItalicTag } from "./styled";
import { useFetchHubParamsData, useGetLocalizationLabel } from "./useFetchAPIData";
import { withRouter } from 'react-router-dom';
import { MdWarning, MdClose } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa";
import Spinner from "components/common/LegacySpinner";
import Tooltip from "components/common/Tooltip";
import FormComponents from "./FormComponents";
import { TableRowProps, TableCellClass, commonFields, hubAndCAMode, commonErrorFields, useInterval, replaceString,
    isEmpty, initialState, getFormDataPayload, numberFields, fileInputFields, userAccessPermission } from "./constants";
import { ModelBodyDiv, HeaderTitle, FooterButtons } from "../ManageSignCertificate/styled";
import { StyledWrapper, MultiTagWrapper, StyledInput, UploadButton, FormErrorSectionDiv } from "./FormComponents";
import { BsFillXOctagonFill } from "react-icons/bs";
import { setAmplitudeEvent } from "amplitude/amplitude";
import { useDateTimeByUserFormat } from "utils";

const ViewHubParameters = ({ history }) => {
    const [state, setState] = useState(initialState);
    const [formError, setFormError] = useState({});
    const rootFileRef = useRef(null);
    const OpFileRef = useRef(null);
    const { data, error: apiError, errorMessage, loading, submitForm, setAPIHookData, hubServerStatus,
        fileUploadError, fileUploading, getCertificateDetails, refetch, certificateDetails, downloadRootCertificate,
        applicationAccess, hubRootCertName, hubOperationCertName } = useFetchHubParamsData(history);
    const { getLabel, getFormErrorLabel, getMultipleErrorString } = useGetLocalizationLabel();
    const { getDateTimeValue } = useDateTimeByUserFormat();
    useInterval(() => {
        refetch(state, true);
        getCertificateDetails(state, true);
    }, 10000);
    useEffect(() => {
        if (typeof applicationAccess === "string" && applicationAccess.includes(`${userAccessPermission.None}`)) {
            history.push("/UserNotAuthorized");
        }
    }, [applicationAccess]);

    useEffect(() => {
        if (state.rootCertificateRequest && state.rootCertificateRequest.length) {
            setState(prevState => ({...prevState, selectedFileKey: "rootCertificateRequest", isModelOpen: true}));
        }
        if (rootFileRef && rootFileRef.current && !state.rootCertificateRequest) {
            rootFileRef.current.value = "";
        }
    }, [state.rootCertificateRequest]);

    useEffect(() => {
        if (state.operationalCertificateRequest && state.operationalCertificateRequest.length) {
            setState(prevState => ({...prevState, selectedFileKey: "operationalCertificateRequest", isModelOpen: true}));
        }
        if (OpFileRef && OpFileRef.current && !state.operationalCertificateRequest) {
            OpFileRef.current.value = "";
        }
    }, [state.operationalCertificateRequest]);

    useEffect(() => {
        if (data) {
            const updatedData = resetObjectData(state, data);
            setState(updatedData);
        }
    }, [data]);

    useEffect(() => {
        if (state.selectedCertificate) {
            onToggleModel();
        }
    }, [state.selectedCertificate]);

    const onChangeCheckbox = (updatedValue) => {
        setState(prevState => ({...prevState, certGenType: updatedValue}));
    }

    const getAutoGenComponent = () => {
        return (<AutoGenDiv>
                    <input
                        type="checkbox"
                        id="certGenType"
                        checked={state["certGenType"]}
                        onChange={(e) => onChangeCheckbox(e.target.checked)}
                        // disabled={!state["isHubServerEnabled"]}
                    />
                    <label for="certGenType">{getLabel("AutoGenerateCertificates") ?
                        getLabel("AutoGenerateCertificates") : "Auto Generate Certificates"}</label>
            </AutoGenDiv>);
    }
    const getFileSelectionComp = (idValue) => {
        return (<StyledWrapper>
            <MultiTagWrapper>
                {
                    idValue === "rootCertificateRequest" && hubRootCertName ? <div id="cert-name">{ hubRootCertName }</div> : null
                }
                {
                    idValue !== "rootCertificateRequest" && hubOperationCertName ? <div id="cert-name">{ hubOperationCertName }</div> : null
                }
                {formError[idValue] && !state.selectedFileKey ? <FormErrorSectionDiv><BsFillXOctagonFill />
                    <p>{formError[idValue]}</p></FormErrorSectionDiv> : null}
            </MultiTagWrapper>
            <StyledInput
                id={`input_${idValue}`}
                name={`input_${idValue}`}
                type="file"
                accept=".pem"
                ref={idValue === "rootCertificateRequest" ? rootFileRef : OpFileRef }
                onChange={(event) =>
                    onChangeFields(idValue, Array.from(event.target.files), event)
                }
            />
            <UploadButton
                ml="3px"
                for={`input_${idValue}`}>
                {getLabel("ChooseFile") ? getLabel("ChooseFile") : "Choose File"}
            </UploadButton>
        </StyledWrapper>)
    }

    const editCompConfig = [
        {
            label: getLabel("Mode") ? getLabel("Mode") : "Mode",
            id: "hubMode",
            compType: "dropdown",
            showComp: true,
            value: state["hubMode"],
            options: data && data.modeOptions ? data.modeOptions : [],
            // disabled: !state["isHubServerEnabled"]
        },
        {
            label: getLabel("Port") ? getLabel("Port") : "Port",
            id: "portNumber",
            compType: "input",
            type: "number",
            showComp: true,
            value: state["portNumber"],
            min: "1",
            error: formError["portNumber"] ? formError["portNumber"] : "",
            // disabled: !state["isHubServerEnabled"]
        },
        {
            label: getLabel("PrimaryHubURL") ? getLabel("PrimaryHubURL") : "Primary Hub URL",
            id: "primaryHubURI",
            compType: "input",
            type: "text",
            showComp: true,
            value: state["primaryHubURI"],
            error: formError["primaryHubURI"] ? formError["primaryHubURI"] : "",
            // disabled: !state["isHubServerEnabled"]
        },
        {
            label: getLabel("FailoverHubURL") ? getLabel("FailoverHubURL") : "Failover Hub URL",
            id: "failoverHubURI",
            compType: "input",
            type: "text",
            showComp: true,
            value: state["failoverHubURI"],
            error: formError["failoverHubURI"] ? formError["failoverHubURI"] : "",
            // disabled: !state["isHubServerEnabled"]
        },
        {
            label: state["hubMode"] === "2" ? getAutoGenComponent() : null,
            id: "certGenType",
            compType: () => (state["hubMode"] === "1" ? <GenCSRButton variant="contained" onClick={()=>downloadRootCertificate("New Request.csr", true)}>{getLabel("GenerateNewCSR") ? getLabel("GenerateNewCSR") : "Generate New CSR"}</GenCSRButton> : null),
            type: "save",
            showComp: state["hubMode"] === "1"
        },
        {
            label: getLabel("CACertificate") ? getLabel("CACertificate") : "CA Certificate",
            id: "rootCertificateRequest",
            compType: () => getFileSelectionComp("rootCertificateRequest"),
            showComp: !state["certGenType"] || state["hubMode"] === "1",
            value: (state["rootCertificateRequest"] && state["rootCertificateRequest"].length) ? state["rootCertificateRequest"][0].name : "",
            error: formError["rootCertificateRequest"] ? formError["rootCertificateRequest"] : "",
            // disabled: !state["isHubServerEnabled"],
            accept: ".pem"
        },
        {
            label: getLabel("IssuerCertificate") ? getLabel("IssuerCertificate") : "Issuer Certificate",
            id: "issuerCertFile",
            compType: "file",
            showComp: !state["certGenType"] && state["hubMode"] === "1",
            value: (state["issuerCertFile"] && state["issuerCertFile"].length) ? state["issuerCertFile"][0].name : "",
            error: formError["issuerCertFile"] ? formError["issuerCertFile"] : "",
            // disabled: !state["isHubServerEnabled"],
            accept: ".pem"
        },
        {
            label: getLabel("IssuerSubjectName") ? getLabel("IssuerSubjectName") : "Issuer Subject Name (CN)",
            id: "issuerCertificate",
            compType: "input",
            type: "text",
            showComp: state["certGenType"] && state["hubMode"] !== "1",
            value: state["issuerCertificate"],
            error: formError["issuerCertificate"] ? formError["issuerCertificate"] : "",
            // disabled: !state["isHubServerEnabled"]
        },
        {
            label: getLabel("IssuerCertificateValidity") ? getLabel("IssuerCertificateValidity") : "Issuer Certificate Validity",
            id: "issuerCertValidityYear",
            compType: "input",
            type: "number",
            showComp: state["certGenType"] && state["hubMode"] !== "1",
            value: state["issuerCertValidityYear"],
            min: "1",
            error: formError["issuerCertValidityYear"] ? formError["issuerCertValidityYear"] : "",
            // disabled: !state["isHubServerEnabled"],
            affixLabel: "Years" 
        },
        {
            label: getLabel("HubOperationalCertificateValidity") ? getLabel("HubOperationalCertificateValidity") : "Hub Operational Certificate Validity",
            id: "oprCertValidityYear",
            compType: "input",
            type: "number",
            showComp: state["hubMode"] === "2",
            value: state["oprCertValidityYear"],
            min: "1",
            error: formError["oprCertValidityYear"] ? formError["oprCertValidityYear"] : "",
            // disabled: !state["isHubServerEnabled"],
            affixLabel: "Years" 
        },
        {
            label: getLabel("OperationalCertificate") ? getLabel("OperationalCertificate") : "Operational Certificate",
            id: "operationalCertificateRequest",
            compType: () => getFileSelectionComp("operationalCertificateRequest"),
            showComp: state["hubMode"] === "1",
            value: (state["operationalCertificateRequest"] && state["operationalCertificateRequest"].length) ? state["operationalCertificateRequest"][0].name : "",
            error: formError["operationalCertificateRequest"] ? formError["operationalCertificateRequest"] : "",
            // disabled: !state["isHubServerEnabled"],
            accept: ".pem"
        },
        {
            label: getLabel("TLSVersion") ? getLabel("TLSVersion") : "TLS Version",
            id: "tlsVersion",
            compType: "dropdown",
            showComp: true,
            value: state["tlsVersion"],
            options: data && data.tlsOptions ? data.tlsOptions : [],
            // disabled: !state["isHubServerEnabled"]
        }
    ];

    const getModeLabel = () => {
        if (data && data.hubMode && data.modeOptions && data.modeOptions.length) {
            const modeObject = data.modeOptions.find((item)=> item.value === data.hubMode);
            return modeObject && modeObject.label ? modeObject.label : "--";
        } else {
            return "--";
        }
    }

    const getTlsVersionLabel = () => {
        if (data && data.tlsVersion && data.tlsOptions && data.tlsOptions.length) {
            const modeObject = data.tlsOptions.find((item)=> item.value === data.tlsVersion);
            return modeObject && modeObject.label ? modeObject.label : "--";
        } else {
            return "--";
        }
    }

    const onClickCertificateName = (certificateId) => {
        setState(prevState => ({...prevState, selectedCertificate: certificateId}));
    }

    const showWarningPopup = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleModel}><MdClose /></div>
                    <label>{getLabel("Alert") ? getLabel("Alert") : "Alert"}</label>
                </HeaderTitle>
                <div id="alert-content">
                    {getLabel("AlertMessageOnApply") ? getLabel("AlertMessageOnApply") : "Applying these changes would impact communication with buildings. Are you sure you want to apply these changes ?"}
                </div>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <Button  id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("No") ? getLabel("No") : "No"}</Button>
                        <Button id="apply_button" variant="contained" onClick={onClickYes}>{getLabel("Yes") ? getLabel("Yes") : "Yes"}</Button>
                    </EditActions>
                </FooterButtons>      
            </ModelBodyDiv>
        );
    }

    const getTooltipComponent = (fieldKey) => {
        if (hubServerStatus && hubServerStatus.errors && hubServerStatus.errors[fieldKey] && hubServerStatus.errors[fieldKey].errorCode 
            && hubServerStatus.errors[fieldKey].errorCode !== "ERRCE0000" && hubServerStatus.errors[fieldKey].errorCode !== "ERRHE0000") {
            return (<Tooltip 
                        title={getMultipleErrorString(hubServerStatus.errors[fieldKey].errorCode, ",")}
                        placement="right">
                            <ErrorIconContainer>
                                <MdWarning />
                            </ErrorIconContainer>
                </Tooltip>);
        } else {
            return null;
        }
    }

    const viewModeComponent = () => {
        return (<ViewTableContainer>
            <Table size="small" aria-label="simple table"  id="view-hub-params-table" className={`material-ui-table`}>
                <TableBody className="material-ui-table-body">
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("Mode") ? getLabel("Mode") : "Mode"}</TableCell>
                        <TableCell {...TableCellClass}>
                            { getModeLabel() }
                        </TableCell>
                    </TableRow>
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("Port") ? getLabel("Port") : "Port"}</TableCell>
                        <TableCell {...TableCellClass}>
                            {data && data.portNumber ? data.portNumber : "--"}
                            {
                                getTooltipComponent("portNumber")
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("PrimaryHubURL") ? getLabel("PrimaryHubURL") : "Primary Hub URL"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {data && data.primaryHubURI ? data.primaryHubURI : "--"}
                                {
                                    getTooltipComponent("primaryHubURI")
                                }
                            </TableCell>
                    </TableRow>
                    <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("FailoverHubURL") ? getLabel("FailoverHubURL") : "Failover Hub URL"}</TableCell>
                            <TableCell {...TableCellClass}>{data && data.failoverHubURI ? data.failoverHubURI : "--"}</TableCell>
                    </TableRow>
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("VMAC") ? getLabel("VMAC") : "VMAC"}</TableCell>
                        <TableCell {...TableCellClass}>{data && data.vmac ? data.vmac : "--"}</TableCell>
                    </TableRow>
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("CACertificate") ? getLabel("CACertificate") : "CA Certificate"}</TableCell>
                        <TableCell {...TableCellClass}>
                            {data && data.rootCertificate ? <HyperLinkDiv 
                            onClick={()=>onClickCertificateName("rootCert")}>{data.rootCertificate}{getTooltipComponent("rootCertificate")}</HyperLinkDiv> : "--"}
                        </TableCell>
                        <TableCell {...TableCellClass}><label>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</label></TableCell>
                        <TableCell {...TableCellClass}>{data && data.rootCertificateValidity ? getDateTimeValue(data.rootCertificateValidity) : "--"}</TableCell>
                        {/* <TableCell {...TableCellClass}>
                            <Button variant="contained">Download</Button>
                        </TableCell> */}
                    </TableRow>
                    {
                        state["hubMode"] === "2" ? <TableRow {...TableRowProps}>
                            <TableCell {...TableCellClass}>{getLabel("IssuerCertificate") ? getLabel("IssuerCertificate") : "Issuer Certificate"}</TableCell>
                            <TableCell {...TableCellClass}>
                                {data && data.issuerCertificate ?<HyperLinkDiv  onClick={()=>onClickCertificateName("issuerCert")}>
                                    {data.issuerCertificate}{getTooltipComponent("issuerCertificate")}</HyperLinkDiv> : "--"}
                            </TableCell>
                            <TableCell {...TableCellClass}><label>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</label></TableCell>
                            <TableCell {...TableCellClass}>{data && data.issuerCertificateValidity ? getDateTimeValue(data.issuerCertificateValidity) : "--"}</TableCell>
                            {/* <TableCell {...TableCellClass}>
                                <Button variant="contained">Download</Button>
                            </TableCell> */}
                        </TableRow> : null
                    }
                    
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("OperationalCertificate") ? getLabel("OperationalCertificate") : "Operational Certificate"}</TableCell>
                        <TableCell {...TableCellClass}>
                            {data && data.operationalCertificate ? <HyperLinkDiv  onClick={()=>onClickCertificateName("operationalCert")}>
                                {data.operationalCertificate}{getTooltipComponent("operationalCertificate")}</HyperLinkDiv> : "--"}
                        </TableCell>
                        <TableCell {...TableCellClass}><label>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</label></TableCell>
                        <TableCell {...TableCellClass}>{data && data.operationalCertificateValidity ? getDateTimeValue(data.operationalCertificateValidity) : "--"}</TableCell>
                        {/* <TableCell {...TableCellClass}>
                            <Button variant="contained">Download</Button>
                        </TableCell> */}
                    </TableRow>
                    <TableRow {...TableRowProps}>
                        <TableCell {...TableCellClass}>{getLabel("TLSVersionAllowed") ? getLabel("TLSVersionAllowed") : "TLS Version Allowed"}</TableCell>
                        <TableCell {...TableCellClass}>{ getTlsVersionLabel() }
                        {
                            getTooltipComponent("tlsVersion")
                        }
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </ViewTableContainer>);
    }

    // Automatically update Primary URI when changing the port
    const getUpdatedPrimaryURL = (primaryURLString, updatedPortNumber) => {
        if (primaryURLString && primaryURLString.length) {
            const startIndex = primaryURLString.lastIndexOf(":") + 1;
            const endIndex = primaryURLString.substring(startIndex).indexOf("/") + startIndex;
            return replaceString(primaryURLString, startIndex, endIndex, updatedPortNumber);
        } else {
            return primaryURLString;
        }
    }
    
    const onChangeFields = useCallback((id, value)=>{
        let updatedErrorValue = {...formError};
         // Empty check for input fields and ignore failover field
         if (!value && id !== "failoverHubURI") {
            updatedErrorValue = { ...updatedErrorValue, [id]: getFormErrorLabel(id) }
        } else {
            if (updatedErrorValue[id]) {
                const clonedObject = {...updatedErrorValue};
                delete clonedObject[id];
                updatedErrorValue = clonedObject;
            }
        }
        if (fileInputFields.includes(id) && value && value.length) {
            const fileName = value[0].name.split(".");
            if (fileName[fileName.length - 1] !== "pem" && fileName[fileName.length - 1] !== "PEM") {
                updatedErrorValue[id] = getFormErrorLabel("InvalidFile");
            }
        } 
        if (id === "portNumber") { // Update Primary URI when changing the port
            setState(prevState => ({
                ...prevState,
                [id]: value,
                primaryHubURI: getUpdatedPrimaryURL(prevState.primaryHubURI, value)
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                [id]: value
            }));
        }
        if ((isEmpty(updatedErrorValue) && state.isFormError) || (id === "hubMode")) {
            setState(prevState => ({ ...prevState, isFormError: false }));
        }
        setFormError(updatedErrorValue);
    }, [formError]);

    // const onChangeHubServer = (updatedValue) => {
    //     setState(prevState => ({...prevState, isHubServerEnabled: updatedValue}));
    // }

    const editModeComponent = () => {
        return (<EditTableContainer>
            <Table size="small" aria-label="simple table"  id="view-hub-params-table" className={`material-ui-table`}>
                <TableBody className="material-ui-table-body">
                    {
                        editCompConfig.map((item) => {
                            return item.showComp ? <TableRow {...TableRowProps}>
                                <TableCell>{item.label}</TableCell>
                                <TableCell {...TableCellClass}>
                                    <FormComponents
                                        {...item}
                                        onChange={onChangeFields}
                                    />
                                </TableCell>
                            </TableRow> : null
                        })
                    }
                </TableBody>
            </Table>
        </EditTableContainer>);
    }

    const getCertificateName = (originalName, onlyName) => {
        let updatedName = originalName;
        if (updatedName) {
            if (updatedName.split(" ")[0].includes("CN=")) {
                updatedName = updatedName.split(" ")[0].replace("CN=", "").replace(",", "");
            } else {
                updatedName = updatedName.split(" ")[1].replace("CN=", "").replace(",", "");
            }
            if (onlyName) {
                updatedName = `${updatedName}`;
            } else {
                updatedName = `${getLabel("CertificateDetails") ? getLabel("CertificateDetails") : "Certificate Details for"} ${updatedName}`;
            }
        } else {
            updatedName = "--";
        }
        return updatedName;
    }

    const showCertificateDetails = () => {
        const { selectedCertificate } = state;
        const { rootCertDetails, issuerCertDetails, operationCertDetails } = certificateDetails;
        let title = "--", certificateName = "--";
        const details = (selectedCertificate === "rootCert" && rootCertDetails) ? rootCertDetails : (selectedCertificate === "issuerCert" && issuerCertDetails) ? issuerCertDetails : 
            (selectedCertificate === "operationalCert" && operationCertDetails) ? operationCertDetails : null;
        if (selectedCertificate === "rootCert") {
            title = getCertificateName(data.rootCertificate);
            certificateName = data.rootCertificate ? data.rootCertificate : "--";
        } else if (selectedCertificate === "issuerCert") {
            title = getCertificateName(data.issuerCertificate);
            certificateName = data.issuerCertificate ? data.issuerCertificate : "--";
        } else if(selectedCertificate === "operationalCert") {
            title = getCertificateName(data.operationalCertificate);
            certificateName = data.operationalCertificate ? data.operationalCertificate : "--";
        }
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleModel}><MdClose /></div>
                    <label>{title}</label>
                </HeaderTitle>
                <CertDetailsTable>
                    <tbody>
                        <tr>
                            <td>{getLabel("DistinguishedName") ? getLabel("DistinguishedName") : "Distinguished Name"}</td><td>{certificateName}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("IssuedBy") ? getLabel("IssuedBy") : "Issued By"}</td><td>{details ? details.issuerCertificateSubjectName : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotBefore") ? getLabel("NotBefore") : "Not Before"}</td><td>{details ? getDateTimeValue(details.validFrom) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotAfter") ? getLabel("NotAfter") : "Not After"}</td><td>{details ? getDateTimeValue(details.validTo) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("Thumbprint") ? getLabel("Thumbprint") : "Thumbprint"}</td><td>{details ? details.thumbprint : "--"}</td>
                        </tr>
                    </tbody>
                </CertDetailsTable>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        {
                            selectedCertificate === "rootCert" ? <Button id="apply_button" variant="contained"
                                onClick={() => downloadRootCertificate(`${getCertificateName(data.rootCertificate, true)}.pem`)}>{getLabel("Download") ? getLabel("Download") : "Download"}</Button> : null
                        }
                        <Button  id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("Close") ? getLabel("Close") : "Close"}</Button>
                    </EditActions>
                </FooterButtons>    
            </ModelBodyDiv>
        );
    }

    const formErrorValidation = () => {
        const validateFields = state["hubMode"] === "1" ? commonErrorFields : commonErrorFields.concat(hubAndCAMode);
        let errorObject = {};
        validateFields.map(fieldKey => {
            if (!state[fieldKey] || (numberFields.includes(fieldKey) && Number(state[fieldKey]) === 0)) {
                errorObject[fieldKey] = getFormErrorLabel(fieldKey)
            } else {
                delete errorObject[fieldKey];
            }
            return fieldKey;
        });

        if (state["hubMode"] === "1" && !state.isModelOpen) {
            if (hubRootCertName === "") {
                errorObject["rootCertificateRequest"] = getFormErrorLabel("rootCertificateRequest");
            } else {
                delete errorObject["rootCertificateRequest"];
            }
            if (hubOperationCertName === "") {
                errorObject["operationalCertificateRequest"] = getFormErrorLabel("operationalCertificateRequest");
            } else {
                delete errorObject["operationalCertificateRequest"];
            }
        }
        
        if (state["hubMode"] === "1" && state.isModelOpen) {
            fileInputFields.map(fieldKey => {
                if (state[fieldKey] && state[fieldKey].length) {
                    const fileName = state[fieldKey][0].name.split(".");
                    if (fileName[fileName.length - 1] !== "pem" && fileName[fileName.length - 1] !== "PEM") {
                        errorObject[fieldKey] = getFormErrorLabel("InvalidFile");
                    }
                }
                return fieldKey;
            });

        }
        return { isFormError: !isEmpty(errorObject), errorValue: errorObject };
    }

    const resetObjectData = (currentData, originalData) => { 

        if (currentData && Object.keys(currentData) && Object.keys(currentData).length) {
            const updatedObject = {...currentData};
            Object.keys(currentData).map(fieldKey => {
                if (originalData && originalData.hasOwnProperty(fieldKey)) {
                    updatedObject[fieldKey] = originalData[fieldKey];
                }
                return fieldKey;
            });
            return updatedObject;
        } else {
            return currentData;
        }
    }
    const submitCallback = (status) => {
        if (status === "success") {
            setState(prevState => ({...prevState, isFormError: false, editMode: false}));
            setFormError({});
            refetch();
            getCertificateDetails();
        }
    }
    
    const onClickYes = () => {
        const filedKeys =  state["hubMode"] === "1" ? commonFields : commonFields.concat(hubAndCAMode);
        const payload = getFormDataPayload(state, filedKeys);
        submitForm(payload, submitCallback);
        const modeObject = data.modeOptions.find((item)=> item.value === state["hubMode"]);        
        setAmplitudeEvent("Hub Setup",{"Hub Mode": modeObject && modeObject.label ? modeObject.label : "--"});
        setState(prevState => ({...prevState, isModelOpen: false}));
    }

    const onClickApply = () => {
        setAPIHookData(prevState => ({...prevState, error: false, errorMessage: ""}));
        const { isFormError, errorValue } = formErrorValidation();
        if (isFormError) {
            setFormError(errorValue);
            setState(prevState => ({...prevState, isFormError: true, isModelOpen: false}));
        } else {
            setFormError(errorValue);
            setState(prevState => ({...prevState, isFormError: false, isModelOpen: true}));
        }
    }

    const onClickCancel = () => {
        const updatedData = resetObjectData({...state, ...initialState}, data ? data : {} );
        setState(prevState => ({...prevState, ...updatedData, editMode: false, isFormError: false}));
        setFormError({});
        if (data.hubMode === "1") {
            setAPIHookData(prevState => ({...prevState,
                loading: false,
                error: false,
                errorMessage: "",
                hubRootCertName: data.rootCertificate ? `${data.rootCertificate} ${getLabel("ExpiresOn") ? getLabel("ExpiresOn") : "expires on"} ${data.rootCertificateValidity}` : "",
                fileUploadError: "",
                hubOperationCertName: data.operationalCertificate ? `${data.operationalCertificate} ${getLabel("ExpiresOn") ? getLabel("ExpiresOn") : "expires on"} ${data.operationalCertificateValidity}` : ""
            }));
        } else {
            setAPIHookData(prevState => ({...prevState, loading: false, error: false, errorMessage: "", hubRootCertName: "", fileUploadError: "", hubOperationCertName: ""}));
        }
    }

    const onToggleModel = () => {
        setState(prevState => ({
            ...prevState,
            isModelOpen: !prevState.isModelOpen,
            selectedCertificate: prevState.isModelOpen ? null : prevState.selectedCertificate,
            selectedFileKey: null,
            operationalCertificateRequest: "",
            rootCertificateRequest: ""
        }));
        let updatedFormError = {...formError}
        delete updatedFormError.operationalCertificateRequest;
        delete updatedFormError.rootCertificateRequest;
        setFormError(updatedFormError);
    }

    const onToggleOverWriteModel = () => {
        setAPIHookData(prevState => ({...prevState, fileUploadError: ""}));
        setState(prevState => ({
            ...prevState,
            showOverWriteWarning: false
        }));
    }

    const fileUploadCallback = (status, error) => {
        if (status === "success") {
            onToggleModel();
        }
    }

    const uploadCertificateFile = (isOverwrite) => {
        if (state.selectedFileKey === "rootCertificateRequest") {
            if (state.rootCertificateRequest && state.rootCertificateRequest.length) {
                if (isOverwrite) {
                    setState((prevState) => ({...prevState, showOverWriteWarning: true}));
                } else {
                    setState((prevState) => ({...prevState, showOverWriteWarning: false}));
                    const payload = new FormData();
                    payload.append("file", state.rootCertificateRequest[0]);
                    submitForm(payload, fileUploadCallback, state.selectedFileKey, state.hubMode);
                }
            } else {
                let updatedError = {...formError};
                updatedError["rootCertificateRequest"] = "No certificate file selected";
                setFormError(updatedError);
            }
        } else {
            if (state.operationalCertificateRequest && state.operationalCertificateRequest.length) {
                if (isOverwrite) {
                    setState((prevState) => ({...prevState, showOverWriteWarning: true}));
                } else {
                    setState((prevState) => ({...prevState, showOverWriteWarning: false}));
                    const payload = new FormData();
                    payload.append("file", state.operationalCertificateRequest[0]);
                    submitForm(payload, fileUploadCallback, state.selectedFileKey, state.hubMode);
                }
            } else {
                let updatedError = {...formError};
                updatedError["operationalCertificateRequest"] = "No certificate file selected";
                setFormError(updatedError);
            }
        }
    }

    const onClickImport = () => {
        if (((state.selectedFileKey === "rootCertificateRequest" && hubRootCertName !== "") 
            || (state.selectedFileKey === "operationalCertificateRequest" && hubOperationCertName !== ""))) {
            uploadCertificateFile(true);
        } else {
            uploadCertificateFile();
        }
    }

    const getModelModelBodyComp = () => {
        if(state.selectedCertificate) {
            return showCertificateDetails();
        }else if(state.selectedFileKey) {
            return showCertUploadModel();
        }else {
            return showWarningPopup();
        }
    }

    const certificateName = state.selectedFileKey === "rootCertificateRequest" ? "CA Certificate" : "Operational Certificate";
    
    const showCertUploadModel = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleModel}><MdClose /></div>
                    <label>{getLabel("Import") ? getLabel("Import") : "Import"} {state.selectedFileKey === "rootCertificateRequest" ? "CA Certificate" : "Operational Certificate"}</label>
                </HeaderTitle>
                <div id="alert-content">Selected {state.selectedFileKey === "rootCertificateRequest" ? "CA Certificate" : "Operational Certificate"} file to import</div>
                {
                    state.selectedFileKey === "rootCertificateRequest" ? <FormComponents
                            {...editCompConfig[5]}
                            compType="file"
                            onChange={onChangeFields}
                        /> : <FormComponents
                        {...editCompConfig[10]}
                        compType="file"
                        onChange={onChangeFields}
                    />
                }
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        <Button  id="cancel_button" variant="contained" onClick={onToggleModel}>{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</Button>
                        <Button id="apply_button" variant="contained" onClick={onClickImport}>{getLabel("Import") ? getLabel("Import") : "Import"}</Button>
                    </EditActions>
                </FooterButtons>
            </ModelBodyDiv>
        );
    }

    const overwriteWarningModel = () => {
        return <>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleOverWriteModel}><MdClose /></div>
                    <label>{getLabel("ConfirmImport") ? getLabel("ConfirmImport") : "Confirm Import"} {certificateName}</label>
                </HeaderTitle>
                <div id="alert-content">
                    You are about to import a new {certificateName} This will replace 
                    the current {certificateName} for this link. Do you want to overwrite the existing certificate?
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <Button  id="cancel_button" variant="contained" onClick={onToggleOverWriteModel}>{getLabel("NoCancel") ? getLabel("NoCancel") : "No - Cancel"}</Button>
                    <Button id="apply_button" variant="contained" onClick={()=>uploadCertificateFile()}>{getLabel("YesOverwrite") ? getLabel("YesOverwrite") : "Yes - Overwrite"}</Button>
                </EditActions>
                </FooterButtons>
            </>
    }

    const fileUploadErrorModel = () => {
        return <>
                <HeaderTitle id="header-title" errorTitle>
                    <div onClick={onToggleOverWriteModel}><MdClose /></div>
                    <label><BsFillXOctagonFill />{getLabel("ImportCertificateError") ? getLabel("ImportCertificateError") : "Import Certificate Error"}</label>
                </HeaderTitle>
                <div id="import-file-error">
                {getLabel("ImportCertificateErrorMessage") ? getLabel("ImportCertificateErrorMessage") : "The following error occurred while importing certificate..."}
                </div>
                <div id="import-file-error-message">
                    {fileUploadError}
                </div>
                <FooterButtons id="model-footer-section">
                <EditActions isOverwriteModel>
                    <Button  id="cancel_button" variant="contained" onClick={onToggleOverWriteModel}>{getLabel("OK") ? getLabel("OK") : "OK"}</Button>
                </EditActions>
                </FooterButtons>
            </>
    }

    return <>
    {
        applicationAccess === null ?  (<div>
            { loading ? <SpinnerContainer>
                    <Spinner />
                </SpinnerContainer> : apiError ? <ErrorSection>
                    <ErrorSectionDiv>
                        <MdWarning />
                        <label>{errorMessage}</label>
                    </ErrorSectionDiv>
                </ErrorSection> : null
            }
        </div>) : null
    }
    {
        applicationAccess !== null ? (<ViewHubParaContainer id="ViewHubParameters">
                <h3>{getLabel("EditHeaderTitle") && state.editMode ? getLabel("EditHeaderTitle") : state.editMode ?
                    "Edit Hub Parameters" : getLabel("ViewHeaderTitle") ? getLabel("ViewHeaderTitle") : "View Hub Parameters" }
                </h3>
                <SubHeaderSection>
                    {/* {
                        state.editMode ? <HubServerStatus>
                            <input
                                type="checkbox"
                                checked={state.isHubServerEnabled}
                                onChange={(e)=>onChangeHubServer(e.target.checked)}
                                id="enableHubServer"
                            />
                            <label for="enableHubServer">Enable Ensemble Hub Server</label>
                        </HubServerStatus> : <label id="hub_server_status">Ensemble Hub Server Enabled: Yes</label>
                    } */}
                    <label id="hub_server_status">
                        {getLabel("ServerEnabledStatus") ? getLabel("ServerEnabledStatus") : "Ensemble Hub Server Enabled:"} {state["isHubServerEnabled"] ? 
                            <StatusItalicTag>{getLabel("Yes") ? getLabel("Yes") : "Yes"}</StatusItalicTag> : <StatusItalicTag error>{getLabel("No") ? getLabel("No") : "No"}</StatusItalicTag>}
                    </label>
                    <label id="hub_server_running_status">{getLabel("ServerRunningStatus") ? getLabel("ServerRunningStatus") : "Ensemble Hub Server Running:"} {
                        hubServerStatus["serverStatus"] ? <StatusItalicTag>{getLabel("Yes") ? getLabel("Yes") : "Yes"}</StatusItalicTag> : hubServerStatus["serverStatus"] === false ?
                        <StatusItalicTag error>{getLabel("No") ? getLabel("No") : "No"}</StatusItalicTag> : "--"
                    }</label>
                </SubHeaderSection>
                {
                    !state.editMode && typeof applicationAccess === "string" && applicationAccess.includes(`${userAccessPermission.Full}`) ? <BackButtonContainer>
                        <Button variant="contained" id="edit-button" onClick={() => setState(prevState => ({ ...prevState, editMode: true }))}>{getLabel("Edit") ? getLabel("Edit") : "Edit"}</Button>
                    </BackButtonContainer> : null
                }
                <div>
                    { loading ? <SpinnerContainer>
                            <Spinner />
                        </SpinnerContainer> : null
                    }
                    {
                        state.editMode ? editModeComponent() : viewModeComponent()
                    }
                </div>
                {
                    apiError ? <ErrorSection>
                        <ErrorSectionDiv>
                            <MdWarning />
                            <label>{errorMessage}</label>
                        </ErrorSectionDiv>
                        <div>
                            <MdClose onClick={() => setAPIHookData(prevState => ({...prevState, error: false, errorMessage: ""}))}/>
                        </div>
                    </ErrorSection> : null
                }
                {
                    //TODO: Make this below alert as common component
                    state.isFormError ? <ErrorSection>
                        <FormErrorContainer>
                            <MdWarning />
                            <b>{getLabel("ErrorAlertTitle") ? getLabel("ErrorAlertTitle") : "Please correct all errors before continuing."}</b>
                            <p>{Object.keys(formError).length} {getLabel("ErrorsOnPage") ? getLabel("ErrorsOnPage") : "error on this page"}</p>
                        </FormErrorContainer>
                        <div>
                            <MdClose onClick={() => setState(prevState => ({ ...prevState, isFormError: false }))}/>
                        </div>
                    </ErrorSection> : null
                }
                <FooterSection>
                    <BackButtonContainer>
                        {
                            !state.editMode ? <Button variant="contained" onClick={() => history.goBack()}>
                                <FaArrowLeft />{getLabel("Back") ? getLabel("Back") : "Back"}
                            </Button>
                            : null
                        }
                    </BackButtonContainer>
                    {
                        state["editMode"] ? <EditActions>
                            <Button  id="cancel_button" variant="contained" onClick={onClickCancel}>{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</Button>
                            <Button id="apply_button" variant="contained" disabled={loading} onClick={onClickApply}>{getLabel("Apply") ? getLabel("Apply") : "Apply"}</Button>
                        </EditActions> : null
                    }
                </FooterSection>
                <HubParamModal
                    isOpen={state.isModelOpen}
                    toggle={onToggleModel}
                    id="view-hub-parameters-model"
                    isAlertModel={state.selectedCertificate}
                    >
                    {
                        getModelModelBodyComp()
                    }
                </HubParamModal>
                <HubParamModal
                    isOpen={state.showOverWriteWarning || fileUploadError}
                    toggle={onToggleOverWriteModel}
                    id="certificate-warning-model"
                    isOverwriteModel
                    fileUploadError={fileUploadError}
                >
                    <ModelBodyDiv>
                        {
                        fileUploadError ? fileUploadErrorModel() : overwriteWarningModel()
                        }
                    </ModelBodyDiv>
                </HubParamModal>
                { fileUploading ? <FileUploadSpinner>
                    <Spinner loadingContent={getLabel("ImportingCertificate") ? getLabel("ImportingCertificate") : "Importing Certificate..."}/>
                </FileUploadSpinner> : null }
            </ViewHubParaContainer>) : null
        }
    </>
    
};

export default withRouter(ViewHubParameters);